<!-- 
  批量转账记录
  lovi 2020-07-29
 -->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{
          $t("transfer.batchTransferRecord")
        }}</BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" v-if="detailFlag || subOrderFlag" @click="returnFun">
        {{ $t("common.back") }}
      </a>
    </div>
    <!-- 列表 -->
    <div v-show="!detailFlag && !subOrderFlag">
      <search
        :dateFlag="true"
        :statusFlag="true"
        :statusList="selectList"
        @search="_getSearch"
      />
      <div class="no-data" v-if="!listData.length && getListFlag">
        <img
          :src="
            require('@/assets/images/public/no_data_' +
              (language == 'en' ? 'en' : 'cn') +
              '.png')
          "
        />
        <p>{{ $t("common.noData") }}</p>
      </div>
      <div class="list-wrap" v-if="listData.length && getListFlag">
        <div
          class="item-list"
          v-for="(item, index) in listData"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="item-l">
            <div class="headimg">
              <img
                :src="
                  item.icon
                    ? httpUrl + item.icon
                    : require('@/assets/images/public/logo_icon@2x.png')
                "
              />
            </div>
            <div class="info">
              <h3>{{ item.type_name }}</h3>
              <p>{{ item.createtime }}</p>
            </div>
          </div>
          <div class="item-r">
            <h4>{{ item.money }}</h4>
            <p :class="item.status_key == 1 ? 'text-red' : 'text-blue'">
              {{ item.status }}
            </p>
          </div>
        </div>
        <div class="total-info-list">
          <div class="total">
            <span>{{ $t("common.totalExpenditure") }}：{{ totalMoney }}P</span>
          </div>
          <div class="page-wrapper" v-if="totalPage > 0">
            <Page
              size="small"
              show-total
              :total="totalPage"
              :current.sync="page"
              @on-change="nextPage"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 详情 -->
    <detail
      v-if="detailFlag"
      :detailFlag.sync="detailFlag"
      :order_id="detail.order_id"
      :type="3"
      @getSubOrder="getSubOrder"
    />

    <!-- 批量充值子订单充值记录 -->
    <sub-order v-if="subOrderFlag" :data="subOrderData" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate } from "@/commonJs";
import Search from "@/components/search";
import Detail from "@/components/detail";
import SubOrder from "@/components/detail/subOrder";
export default {
  name: "transfer-record",
  components: {
    Search,
    Detail,
    SubOrder
  },
  data() {
    return {
      getListFlag: false,
      startDate: formatDate(new Date()), //开始时间
      endDate: formatDate(new Date()), //结束时间
      status: "", //选择类型
      selectList: [],
      page: 1,
      listData: [],
      totalMoney: 0,
      totalPage: 0,

      detailFlag: false, // 详情页Flag
      detail: {},
      subOrderFlag: false, // 子订单Flag
      subOrderData: {} // 子订单data
    };
  },
  created() {
    this.getStatusList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    getStatusList() {
      // 获取状态列表
      let vm = this;
      let params = {};
      params.type = 3;
      vm.$post("/app/help/statusList", params, { loading: true }).then(res => {
        console.log("statusList", res);
        vm.selectList = res;
        vm.status = vm.selectList[0].key;
        vm.getRecordList();
      });
    },
    getRecordList() {
      // 获取状态列表
      let vm = this;
      let params = {};
      params.start_date = vm.startDate;
      params.end_date = vm.endDate;
      params.type = 3;
      params.status = vm.status;
      params.page = vm.page;
      vm.getListFlag = false;
      vm.$post("/app/recharge/rechargeRecordUser", params, {
        loading: true
      }).then(res => {
        console.log("rechargeRecordUser", res);
        vm.getListFlag = true;
        vm.listData = res.list;
        vm.totalPage = res.num;
        vm.totalMoney = res.count;
      });
    },
    returnFun() {
      // 返回
      let vm = this;
      if (vm.subOrderFlag) {
        vm.detailFlag = true;

        vm.subOrderFlag = false;
        vm.batch_id = "";
        vm.order_id = "";
        vm.state = 0;
      } else {
        vm.detailFlag = false;
        vm.detail = {};

        vm.subOrderFlag = false;
        vm.batch_id = "";
        vm.order_id = "";
        vm.state = 0;
      }
    },
    getSubOrder(data) {
      // 获取子订单数据
      let vm = this;
      vm.subOrderFlag = true;
      vm.subOrderData = data;

      vm.detailFlag = false;
    },
    nextPage(data) {
      //跳页
      let vm = this;
      vm.page = data;
      vm.getRecordList();
    },
    _getSearch(data) {
      //搜索
      let vm = this;
      vm.startDate = data.startDate;
      vm.endDate = data.endDate;
      vm.status = data.statusVal;
      vm.page = 1;
      vm.getRecordList();
    },
    toDetail(data) {
      // 详情
      let vm = this;
      vm.detailFlag = true;
      vm.detail = data;
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.total-info-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .total {
    flex: 1;
    line-height: 24px;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-start;
    span {
      margin-right: 10px;
    }
  }
}
.list-wrap {
  padding: 0 50px;
  .noData {
    line-height: 36px;
    text-align: center;
    font-size: 18px;
  }
  .item-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #c9c9c9;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.02);
    }
  }
  .item-l {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .headimg,
    .headimg img {
      width: 54px;
      height: 54px;
      border-radius: 50%;
    }
    .headimg {
      margin-right: 10px;
      background: #ddd;
    }
    h3 {
      font-size: 18px;
      font-weight: 500;
      line-height: 1;
      padding-bottom: 8px;
    }
    p {
      color: #666;
    }
  }

  .item-r {
    flex: 0 0 120px;
    text-align: right;
    h4 {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.5;
      color: #333;
      padding-bottom: 8px;
    }
  }
}
</style>
